import * as React from "react";
import { Card, Title, InputTexto, InputFecha,
         InputSelect, Button, Alert, SubTitle } from "../components";
import '../css/pages/ConsultaCobranzas.css';
import '../css/search-filter/Filter.css';
import '../css/search-result/ResultTable.css';
import { RutValidator, FormatRutValidator, RequiredValidator, ErrorValidations} from "../enums-lists/Validations";
import { Payment, UserState, GroupedPaymentType } from "../types-interfaces/interfaces";
import { EntidadRecaudadora } from "../enums-lists/EntidadRecaudadora";
import { TipoMoneda } from "../enums-lists/TipoMoneda";
import '../css/pages/IngresoPagoManual.css';
import { CollectionLink, PutPayment } from "../services/api-ssrr/CollectionManagerAPIClient";
import { getAccrualDateToApi, getTimestampFromDate } from "../functions/Format";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { useState, useEffect } from "react";
import { AlertVariant } from "../types-interfaces/types";
import { useAppDispatch } from "../redux/hooks";
import { fetchPaymentTypes, selectPaymentTypes } from "../redux/slices/paymentType/PaymentTypeSlice";
import { splitValue } from "../functions/Data";
import InputThousandSeparator from "../components/input/InputThousandSeparator";

interface IngresoPagoManualProps {
  className?: string | undefined
  data?: Array<Array<string>>
  headersName?: Array<string>
}

interface IngresoPagoManualState {
  rut?: string;
  rutPagador?: string;
  entidadRecaudadora: number
  medioPago: string
  tipoMoneda: number
  monto?: string  
  fechaPago?:string  
  fechaDevengo?: string
  calendarHiddenPago?: boolean
  calendarHiddenDevengo?: boolean  
  consultaSinDatos?: boolean
  errorRut?: string
  errorRutPagador?: string
  errorEntidadRecaudadora?: string
  errorMedioPago?: string
  errorTipoMoneda?: string
  errorMonto?: string
  errorFechaPago?: string
  errorFechaDevengo?: string
  estadoConsultaCobranza?: number
  alertVariant?: AlertVariant
  alertText?: string | undefined
  ingresoExitoso: boolean
  paymentTypes: Array<GroupedPaymentType>
};

const initialIngresoPagoManualState: IngresoPagoManualState = {
  rut: "",
  rutPagador: "",
  entidadRecaudadora: -1,
  medioPago: "-1",
  tipoMoneda: 0,
  monto: "",  
  fechaPago: '',
  fechaDevengo: '',
  calendarHiddenPago: true,
  calendarHiddenDevengo: true,
  estadoConsultaCobranza: 1,
  ingresoExitoso: false,
  paymentTypes: [{ value: -1, name: 'Cargando...'}]
}

const fechaCiclo = new Date();  //TODO: arreglar fecha ciclo
const fechaMin = new Date();
fechaMin.setMonth(fechaMin.getMonth()-6);

function IngresoPagoManual(props: IngresoPagoManualProps)  {
  const userState = useSelector<RootState, UserState>((state) => state.userState);
  const [state,setState]=useState(initialIngresoPagoManualState);

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchPaymentTypes(userState, false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const paymentTypesFromAPI = useSelector<RootState, {loading: boolean, paymentTypes: Array<GroupedPaymentType>, error?: boolean}>(selectPaymentTypes);

  useEffect(() => {
    setState({...state,        
      paymentTypes: paymentTypesFromAPI.paymentTypes
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentTypesFromAPI]);

  const rutChangeHandler = ( evt: React.ChangeEvent<HTMLInputElement> ) => {
    let newRut = evt.currentTarget.value.toUpperCase();
    let oldRut = state.rut ?? newRut.substring(0,newRut.length-1);
    const regexp = new RegExp("^[0-9K-]+$");
    if (
      (newRut && !regexp.test(newRut)) ||
      (newRut.startsWith("0") || newRut.startsWith("K")) ||
      (newRut.includes("-") && newRut.split("-").length > 1 && newRut.split("-")[1].length > 1) ||
      (newRut.includes("-") && newRut.lastIndexOf("-") !== newRut.indexOf("-")) ||
      (newRut.includes("K") && newRut.lastIndexOf("K") !== newRut.indexOf("K"))
    ){
      evt.currentTarget.value = oldRut;
    } else {
      setState({ ...state,rut: newRut });
    }    
  }

  const rutPagadorChangeHandler = ( evt: React.ChangeEvent<HTMLInputElement> ) => {
    let newRut = evt.currentTarget.value.toUpperCase();
    let oldRut = state.rutPagador ?? newRut.substring(0,newRut.length-1);
    const regexp = new RegExp("^[0-9K-]+$");
    if (
      (newRut && !regexp.test(newRut)) ||
      (newRut.startsWith("0") || newRut.startsWith("K")) ||
      (newRut.includes("-") && newRut.split("-").length > 1 && newRut.split("-")[1].length > 1) ||
      (newRut.includes("-") && newRut.lastIndexOf("-") !== newRut.indexOf("-")) ||
      (newRut.includes("K") && newRut.lastIndexOf("K") !== newRut.indexOf("K"))
    ){
      evt.currentTarget.value = oldRut;
    } else {
      setState({ ...state,rutPagador: newRut });
    }    
  }

  const entidadRecaudadoraChangeHandler = ( evt: React.ChangeEvent<HTMLSelectElement> ) =>    
    setState({ ...state,entidadRecaudadora: parseInt(evt.currentTarget.value) });
    
  const medioPagoChangeHandler = ( evt: React.ChangeEvent<HTMLSelectElement> ) =>
    setState({ ...state, medioPago: evt.currentTarget.value });
    
  const tipoMonedaChangeHandler = ( evt: React.ChangeEvent<HTMLSelectElement> ) => {
    // eslint-disable-next-line
    if (evt.currentTarget.value === '1' && state.monto!.match(/\,/g)?.length! > 0) {
      setState({ 
        ...state,
        tipoMoneda: parseInt(evt.currentTarget.value),
        monto: state.monto?.split(',')[0]
      });
    } else {
      setState({ ...state, tipoMoneda: parseInt(evt.currentTarget.value) });
    }
  }

  function handlerChangeDate(e:React.ChangeEvent<HTMLInputElement>, date: string): void {
    let oldDate = (date === "fecha-devengo") ? state.fechaDevengo ?? "" : state.fechaPago ?? "";
    let newDate = e.currentTarget.value;
    const regexp = RegExp("^[0-9/]+$");

    if (
      (newDate && !regexp.test(newDate)) ||      
      (newDate.split("/").length === 1 && parseInt(newDate.split("/")[0]) > 31) ||
      (newDate.split("/").length === 2 && parseInt(newDate.split("/")[1]) > 12) ||
      (newDate.split("/").length === 3 && newDate.split("/")[2].length > 4) ||
      (newDate.match(/\//g)?.length === 1 && newDate.indexOf("/",0) !== 2) ||
      (newDate.match(/\//g)?.length === 2 && newDate.indexOf("/",3) !== 5) ||
      (newDate.match(/\//g)?.length ?? 0) > 2 ||
      newDate.length > 10    
      ){
      e.currentTarget.value = oldDate;
    } else {
      let error = (newDate.length>0 && isInvalidDate(newDate)) ? ErrorValidations.InvalidDate : (newDate.length > 0 && newDate.length < 10)? ErrorValidations.Required: "";
      if (date === "fecha-pago"){
        setState({
          ...state,
          fechaPago: newDate,
          errorFechaPago: error,
          calendarHiddenPago: true
        })
      } else {
        setState({
          ...state,
          fechaDevengo:newDate,
          errorFechaDevengo: error,
          calendarHiddenDevengo: true
        })
      }
    }
  }

   function isInvalidDate(date:string): boolean{
    const [day, month, year] = date.split('/');
    const dateObj = new Date(+year, +month - 1, +day);
    return !(dateObj.toLocaleString('es-CL').substring(0,10).replaceAll("-","/") === date);
  }

  function handleClickIngresarPago(){
    if (!state.rut)
    setState({...state,errorRut: "Debes ingresar el RUT del cliente"})

    if (!state.rutPagador)
    setState({...state,errorRutPagador: "Debes ingresar el RUT del pagador"})

    if (state.entidadRecaudadora<1)
    setState({...state,errorEntidadRecaudadora: "Debes seleccionar una entidad recaudadora"})
  
    if (parseInt(state.medioPago) < 1)
    setState({...state,errorMedioPago: "Debes seleccionar el medio de pago"})

    if (state.tipoMoneda<1)
    setState({...state,errorTipoMoneda: "Debes seleccionar un tipo de moneda"})

    if (!state.monto)
    setState({...state,errorMonto: "Debes ingresar un monto"})

    if (!state.fechaPago)
    setState({...state,errorFechaPago: "Debes ingresar una fecha de pago"})

    if (!state.fechaDevengo)
    setState({...state,errorFechaDevengo: "Debes ingresar una fecha de devengo"})

    if (!state.errorRut && !state.errorRutPagador && !state.errorMedioPago &&
      !state.errorEntidadRecaudadora && !state.errorTipoMoneda && !state.errorMonto &&
      !state.errorFechaPago && !state.errorFechaDevengo){
      llamadaAPI();
    }
  }

  async function llamadaAPI(){
    if (state.rut && state.rutPagador && state.entidadRecaudadora &&  state.medioPago &&
      state.tipoMoneda && state.monto &&  state.fechaPago && state.fechaDevengo ){

      const medioPago = splitValue(state.medioPago || "");
      
      let payment:Payment = {
        customerId: state.rut,
        payerId: state.rutPagador,
        paymentCreationDate: getTimestampFromDate(state.fechaPago),
        collectionId: "",
        currencyType: state.tipoMoneda,
        amount:  
          parseFloat(state.tipoMoneda === 1 ?
            state.monto.replaceAll('.','') :
            state.monto.replaceAll('.','').replaceAll(',', '.')),
        paymentType: (1 in medioPago) ? medioPago[1] : medioPago[0],
        company: state.entidadRecaudadora,
        accrualDate: getAccrualDateToApi(state.fechaDevengo),        
      };

      let variant:AlertVariant = undefined;
      let text = undefined;
  
      let response = await PutPayment(payment,userState.currentSession?.accessToken!,userState.currentSession?.user?.email!);
      
      if (!response || typeof(response) === "string"){
        variant = "error";
        text ="No se ha podido ingresar el pago manual correctamente, por favor intente nuevamente.";
      } else {
        let responseLink = await CollectionLink({ paymentIds:[response.paymentId]},userState.currentSession?.accessToken!,userState.currentSession?.user?.email!);
        
        if (!responseLink || typeof(responseLink) === "string" || (typeof(responseLink) === "object" && responseLink.length > 0)){
          variant = "warning";
          text = "Se ha ingresado el pago manual correctamente, pero no se ha vinculado a una cobranza.";
          
        } else if (responseLink && responseLink.length === 0){          
          variant = "success";
          text = "Se ha ingresado el pago manual correctamente, puedes ver más detalle de este en Consultar pagos."     
        }
      }

      setState({
        ...state,
        alertVariant: variant,
        alertText: text,
        rut: initialIngresoPagoManualState.rut,
        rutPagador: initialIngresoPagoManualState.rutPagador,
        entidadRecaudadora: initialIngresoPagoManualState.entidadRecaudadora,
        medioPago: initialIngresoPagoManualState.medioPago,
        tipoMoneda: initialIngresoPagoManualState.tipoMoneda,
        monto: initialIngresoPagoManualState.monto,      
        fechaPago: initialIngresoPagoManualState.fechaPago,      
        fechaDevengo: initialIngresoPagoManualState.fechaDevengo
      });
    }
  }
  
  return(
    <div
      className={props.className}>
      <Title
      className={props.className + '-title'}
      text="Ingreso pago manual"
    />
      <SubTitle
      text="A continuación completa el formulario con la información del pago a guardar."
    />
    {state.alertVariant && 
      <Alert          
        type={state.alertVariant}
        text={state.alertText}
        onClose={() => setState({...state, alertText: undefined, alertVariant: undefined})}
      />    
    }
    <Card className="filter1">
      <Card className="filter-row">
        <InputTexto
          alt="RutCliente"
          className="filter-input"
          label="Ingresa el RUT del cliente"              
          value={state.rut}
          onChange={rutChangeHandler}              
          validators={[FormatRutValidator, RutValidator,RequiredValidator]}
          error={state.errorRut}
        />            
        <InputTexto
          alt="RutPagador"
          className="filter-input"
          label="Ingresa el RUT del pagador"              
          value={state.rutPagador}
          onChange={rutPagadorChangeHandler}
          validators={[FormatRutValidator, RutValidator,RequiredValidator]}
          error={state.errorRutPagador}
        />
        <InputSelect
          className="filter-select"              
          label="Selecciona una entidad recaudadora"              
          value={state.entidadRecaudadora}              
          onChange={entidadRecaudadoraChangeHandler}
          values={EntidadRecaudadora.slice(1,EntidadRecaudadora.length)}
          error={state.errorEntidadRecaudadora}
          required
          data-testid="EntidadRecaudadora"
          showempty = 'true'
        />
      </Card>
      <Card className="filter-row">
          <InputSelect
            className="filter-select"              
            label="Selecciona el medio de pago"              
            value={state.medioPago}              
            onChange={medioPagoChangeHandler}
            values={state.paymentTypes}
            error={state.errorMedioPago}
            required
            data-testid="MedioPago"
            showempty = 'true'
          />
          <InputSelect
            className="filter-select"              
            label="Selecciona el tipo de moneda"              
            value={state.tipoMoneda}              
            onChange={tipoMonedaChangeHandler}
            values={TipoMoneda}
            error={state.errorTipoMoneda}
            required
            data-testid="TipoMoneda"
          />
        <InputThousandSeparator
          value={state?.monto!}
          handleValue={(monto: string) => {
            const newState: string = parseInt(monto) > 0 ? "" : "Debes ingresar un monto"
            setState({ ...state, monto: monto, errorMonto: newState });
          }}
          alt="InputMonto"
          className="filter-input"
          label="Ingresa el monto"   
          validators={[RequiredValidator]}
          error={state.errorMonto!}
          allowComma={state.tipoMoneda === 2 ? true : false}
        />
      </Card>
      <Card className="filter-row">
        <InputFecha
          alt="FechaPago"
          className="filter-fecha"
          label="Ingresa la fecha de pago"
          formatlabel="Usar el formato: DD/MM/AAAA"
          value={state.fechaPago}
          validators={[RequiredValidator]}
          calendarhidden={state.calendarHiddenPago}
          calendarmaxdate={fechaCiclo}
          calendarmindate={fechaMin}
          onClickDay={(e) => {setState({...state,
            fechaPago: e.toLocaleDateString().replaceAll("-","/"),
            calendarHiddenPago: true})}}              
          onClick={() => { setState({...state,
              calendarHiddenPago: !state.calendarHiddenPago,
              calendarHiddenDevengo: true})
          }}
          onMouseOver={() => setState({ ...state,calendarHiddenPago: true})}
          error={state.errorFechaPago}
          onChange={(e) => handlerChangeDate(e,"fecha-pago")}

        />
        <InputFecha
          alt="FechaDevengo"
          className="filter-fecha"
          label="Ingresa la fecha de devengo"
          formatlabel="Usar el formato: DD/MM/AAAA"
          value={state.fechaDevengo}
          calendarhidden={state.calendarHiddenDevengo}
          calendarmaxdate={fechaCiclo}
          calendarmindate={fechaMin}
          onClickDay={(e) => {setState({...state,
            fechaDevengo: e.toLocaleDateString().replaceAll("-","/"),
            calendarHiddenDevengo: true})}}              
          onClick={() => { setState({...state,
            calendarHiddenDevengo: !state.calendarHiddenDevengo,
            calendarHiddenPago: true})
          }}
          onMouseOver={() => setState({ ...state,calendarHiddenDevengo: true})}
          error={state.errorFechaDevengo}
          onChange={(e) => handlerChangeDate(e,"fecha-devengo")}

        />
      </Card>
    </Card>
    <Button
      className={props.className + "-button"}
      text="Ingresar pago"
      onClick={() => handleClickIngresarPago()}
    />
  </div>
  )
}


export default IngresoPagoManual;